<template>
    <div id="app">
        <nav-header/>
        <router-view/>
        <navBottom></navBottom>
    </div>
</template>
<script>
    // @ is an alias to /src
    import navHeader from '../components/navHeader.vue'
    import navBottom from '../components/navBottom.vue'

    export default {
        name: 'pc',
        components: {
            navHeader,
            navBottom
        }
    }
</script>
<style lang="scss">
</style>
